import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";
import { useSelector } from "../../../redux-store";
import { selectSiteJobPositionForCargo } from "../../../ducks/data/site-jobs/selectors";

/**
 * Marks an undispatched order that is one container of a site job, so the
 * dispatcher can see at a glance that it belongs with the orders next to it
 * ("Tømning 1 af 3"). Renders nothing for ordinary orders.
 */
const SiteJobChip = ({ cargoId }: { cargoId: string }) => {
  const { t } = useTranslation("dispatching");
  const position = useSelector(selectSiteJobPositionForCargo(cargoId));
  if (!position) {
    return null;
  }
  return (
    <Chip
      size="small"
      variant="outlined"
      color="primary"
      sx={{ height: 18, fontSize: 11, ".MuiChip-label": { px: 0.75 } }}
      label={t("cargoCard.siteJobChip", {
        kind: t(`cargoCard.siteJobKinds.${position.kind}`),
        position: position.position,
        total: position.total,
      })}
    />
  );
};

export default SiteJobChip;
